export const getDisplayFileSize = (bytes: number) => {
    if (bytes < 1000) {
        return `${bytes} BYTES`
    }

    const kilobytes = bytes / 1000
    if (kilobytes < 1000) {
        return `${Math.floor(kilobytes)} KB`
    }

    const megabytes = kilobytes / 1000

    if (megabytes < 1000) {
        return `${Math.floor(megabytes).toFixed(1)} MB`
    }

    const gigabytes = megabytes / 1000

    return `${gigabytes.toFixed(1)} GB`
}
